import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import Select from 'react-select';
import { setFilterOrderByRefundStatus } from '@/store/modules/refund';
import useGetGlobalStatus from '@/hooks/useGetGlobalStatus';
import { includes } from 'lodash';
import { isNotFiltering } from '@/constants/refundGraph';
interface IProps {
  titleList: CardGraph[];
  hasNotOption?: boolean;
  selectedFilters?: string[];
}

interface CardGraph {
  id: number;
  title: string;
  flex: number;
}

function TableHeader({
  titleList,
  hasNotOption = false,
  selectedFilters,
}: IProps) {
  const { globalStatus } = useGetGlobalStatus();
  const { hospitals, isKioskStore } = useAppSelector((state) => state.user);
  const { filter } = useAppSelector((state) => state.refund);
  const dispatch = useAppDispatch();

  const refundStatusOptions = [
    { label: '환급상태', value: '' },
    { label: '승인', value: 'OK' },
    { label: '취소', value: 'CANCEL' },
    { label: '송금대기', value: 'TRANSFER_CHECK' },
  ];
  const [orderByRefundStatus, setOrderByRefundStatus] = useState<{
    label: string;
    value: string;
  }>(
    refundStatusOptions.find(
      (option) => option.value === filter.orderByRefundStatus,
    ) || refundStatusOptions[0],
  );

  const isHiddenColumn = (title: string) => {
    return (
      selectedFilters &&
      !selectedFilters.includes(title) &&
      !isNotFiltering.includes(title)
    );
  };
  const cardTitle = (title: string) => {
    const onChangeRefundStatus = (e: any) => {
      setOrderByRefundStatus(e);
      dispatch(setFilterOrderByRefundStatus(e.value));
    };

    if (title === '환급상태') {
      return (
        <Select
          isSearchable={false}
          //@ts-ignore
          defaultValue={orderByRefundStatus}
          value={orderByRefundStatus}
          onChange={onChangeRefundStatus}
          //@ts-ignore
          options={refundStatusOptions}
          styles={{
            container: (baseStyles: any) => ({
              ...baseStyles,
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'transparent',
              textAlign: 'center',
            }),
            control: () => ({
              display: 'flex',
              alignItems: 'center',
              minWidth: 100,
              height: 21,
            }),
            indicatorSeparator: () => ({
              width: 0,
            }),
            singleValue: (baseStyles: any) => ({
              ...baseStyles,
              color:
                orderByRefundStatus.value === 'CREATED_DATE'
                  ? '#246CF6'
                  : '#5F6165',
              textOverflow: 'none',
            }),
            dropdownIndicator: (baseStyles: any) => ({
              ...baseStyles,
              color:
                orderByRefundStatus.value === 'CREATED_DATE'
                  ? '#246CF6'
                  : '#5F6165',
              paddingLeft: 0,
            }),
          }}
        />
      );
    }

    return title;
  };

  return (
    <Container>
      {titleList.map((card) => {
        if (isHiddenColumn(card.title)) {
          return null;
        }

        if (hospitals.length === 0 && card.title === '구분' && !hasNotOption) {
          return null;
        }

        if (
          !isKioskStore &&
          card.title === '키오스크 환급액' &&
          !hasNotOption
        ) {
          return null;
        }

        if (
          card.title === '해외\n간편결제' &&
          !globalStatus?.isGlobalPaymentUsable
        ) {
          return null;
        }

        if (card.title === 'No.' && globalStatus?.isChartNumberEnabled) {
          return (
            <Fragment key={card.id}>
              <CardTitle flex={card.flex} isKioskStore={false}>
                {card.title}
              </CardTitle>
              {!isHiddenColumn('차트번호') && (
                <CardTitle
                  flex={1}
                  isKioskStore={false}
                  className='chartNumberHeader'
                >
                  차트번호
                </CardTitle>
              )}
            </Fragment>
          );
        }

        return (
          <Fragment key={card.id}>
            <CardTitle
              flex={card.flex}
              isKioskStore={card.title === '키오스크 환급액'}
            >
              {hasNotOption ? card.title : cardTitle(card.title)}
            </CardTitle>
          </Fragment>
        );
      })}
    </Container>
  );
}

const Container = styled.div`
  min-height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 26px;
  background-color: ${(props) => props.theme.mono[10]};
  border-bottom: 1px solid ${(props) => props.theme.mono[35]};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
`;

const CardTitle = styled.h5<{ flex: number; isKioskStore: boolean }>`
  display: flex;
  flex: ${(props) => props.flex};
  justify-content: center;
  padding: 8px 4px;
  font-size: ${(props) => props.theme.fontSize.xSmall};
  font-weight: ${(props) => props.theme.fontWeight.medium};
  line-height: ${(props) => props.theme.lineHeight.xSmall};
  white-space: pre;
  align-items: center;
  text-align: center;
  color: ${(props) =>
    props.isKioskStore ? props.theme.blue[200] : props.theme.mono[65]};
  @media ${(props) => props.theme.mediumView} {
    padding: 8px 8px;
  }
`;

export default TableHeader;
